import moment from 'moment-timezone';

const timezones = moment.tz.names();

/* eslint-disable import/prefer-default-export */
export const TIMEZONE_OPTIONS = timezones.map(tz => ({ label: tz, value: tz }));

export const US_PUBLIC_HOLIDAYS = 'US Public Holidays';

export const NONE = 'none';
